import React from "react";

import useStyles from "./style";

export default function SubPageContainer({ children }) {
  const classes = useStyles();
  return <div className={classes.wrapper}>{children}</div>;
}
